import styled, { keyframes } from 'styled-components'
import media from '../styles/media'
import Colors from '../styles/Colors'
import { Link } from 'gatsby'
import arrow from 'svg/arrowSmall.svg'
import circleArrow from 'svg/circleArrow.svg'
import arrowReverse from 'svg/arrowReverse.svg'
import largeArrow from 'svg/arrowLarge.svg'

const bgActionIn = keyframes`
0% {height: 100%; width: 100%;}
50% { height: 1px;}
70% {height: 1px; width: 100%;}
100% {width: calc(100% + 2vw); height: 1px;}

`

const bgActionOut = keyframes`
0% {height: 1px; }
 100% { transform: scaleX(0); height: 1px; }
 `

export const TextButton = styled.button`
  position: absolute;
  font-family: 'Maison Neue';
  font-size: 16px; //16px
  line-height: 150%;
  outline: none;
  width: 128px;
  height: 40px;
  background: none;
  border: 1px solid ${Colors.trueBlack};
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.softBlack};
  transition: color 500ms;
  ${media.fullWidth} {
    height: 2.4vw;
    width: 8vw;
    font-size: 1vw;
  }
  :hover {
    color: ${Colors.softBlack48};
  }
  :after {
    content: '';
    width: 100%;
    height: 100%;
    z-index: -1;
    position: absolute;
    background: ${Colors.rossoCorsa};
    animation: ${bgActionOut} 0.5s forwards;
  }
  :active {
    background: white;
    transition: 0.1s;
    transition-timing-function: ease-in-out;
  }
  :active :after {
    animation: ${bgActionOut} 0.1s forwards;
  }

  :hover :after {
    animation-name: ${bgActionIn};
    animation-duration: 0.8s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    animation-fill-mode: forwards;
  }
  ${media.tablet} {
    ::after {
      display: none;
    }
    :active {
      background: none;
      color: ${Colors.softBlack};
    }
  }
`

export const TextLink = styled(Link)`
  position: relative;
  word-wrap: nowrap;
  text-decoration: none;
  font-size: 16px;
  transition: 0.8s;
  transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
  cursor: pointer;
  font-weight: 500;
  color: ${Colors.softBlack};

  :visited {
    color: ${Colors.softBlack};
  }
  &:after {
    content: '';
    position: absolute;
    font-size: 100vw;
    width: 0;
    height: 0.001em;
    top: 8px;
    left: -0.5vw;
    border: none;
    background: ${Colors.rossoCorsa};
    transition: 0.8s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
  }
  &:hover {
    color: ${Colors.softBlack48};
    transition: 0.8s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
  }

  &:hover :after {
    width: calc(100% + 1vw);
    transition: width 0.8s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
  }

  ${media.tablet} {
  }
`

export const ArrowButton = styled.button<{ left?: boolean }>`
  display: flex;
  outline: none;
  background: none;
  border: none;
  width: fit-content;
  flex-direction: ${(props) => (props.left ? 'row-reverse' : 'row')};
  cursor: pointer;
  color: ${Colors.softBlack};
  font-size: 16px;
  font-weight: 500;
  :after {
    content: url(${arrow});
    transform: ${(props) => (props.left ? 'rotate(180deg)' : '')};
    width: 14px;
    transition: 0.4s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    margin-left: ${(props) => (props.left ? '0' : '8px')};
    margin-right: ${(props) => (props.left ? '8px' : '0')};
  }
  :hover {
    color: ${Colors.softBlack48};
    transition: 0.4s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    :after {
      margin-left: ${(props) => (props.left ? '0' : '12px')};
      margin-right: ${(props) => (props.left ? '12px' : '0')};
    }
  }
`

export const ArrowLinkLarge = styled(Link)`
  display: flex;
  background: none;
  border: none;
  display: flex;
  font-family: 'Maison Neue';
  font-size: 24px;
  line-height: 117%;
  font-style: normal;
  font-weight: 500;
  color: ${Colors.trueBlack};
  cursor: pointer;
  :hover {
    color: ${Colors.softBlack48};
    transition: 0.4s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    :after {
      margin-left: 12px;
    }
  }
  :after {
    content: url(${largeArrow});
    width: 21px;
    transition: 0.4s;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    margin-left: 8px;
    margin-top: -1px;
  }

  ${media.tabletLandscape} {
    font-size: 20px;
  }
`

export const CircleButton = styled.button`
  appearance: none;
  outline: none;
  border: none;
  background: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: solid 1px black;
  transition: 0.4s;
  padding: 0;
  transform: rotate(0);
  ::before {
    content: url(${circleArrow});
    width: 100%;
    z-index: 2;
    transition: 0.4s;
    transition-timing-function: ease-out;
  }

  :hover {
    transform: scale(1.05);
    transition: 0.4s;
    transition-timing-function: ease-out;
  }
  :active {
    transform: scale(1) !important;
    background: white;
    transition: 0.4s;
    transition-timing-function: ease-out;
  }

  ${media.tablet} {
  }
`
export const CircleButtonBack = styled.button`
  appearance: none;
  outline: none;
  border: none;
  background: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: solid 1px black;
  transition: 0.4s;
  padding: 0;
  transform: rotate(0);
  ::before {
    content: url(${arrowReverse});
    width: 100%;
    z-index: 2;
    transition: 0.4s;
    transition-timing-function: ease-out;
  }

  :hover {
    transform: scale(1.05);
    transition: 0.4s;
    transition-timing-function: ease-out;
  }
  :active {
    transform: scale(1) !important;
    background: white;
    transition: 0.4s;
    transition-timing-function: ease-out;
  }

  ${media.tablet} {
  }
`
